// extracted by mini-css-extract-plugin
export default {"container":"commentary_subtitle-module__container--2HTee","highlight":"commentary_subtitle-module__highlight--2WR_S"};